<div [innerHTML]="safeHTML(data)"></div>

<!-- <iframe [width]="100" [height]="500"
    [src]="safeHTML(url)" frameborder="0"
    allowfullscreen></iframe> -->

